// test1020
(1020 && 0);
